import './Checkbox.scss';

const Checkbox = (props)=>{
    return (<div className={`checkbox-container ${props.className}`}>
        <div className="checkbox">
            <span className="icon icon-TikMark"></span>
        </div>
    </div>)
}

export default Checkbox;